import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Radio } from '@material-ui/core';
import { hasError } from './_common';

const FormRadio = ({ label, name, value, checked, errors, onChange, ...otherProps }) => (
  <FormControl component="fieldset" error={hasError(errors, name)}>
    <FormControlLabel
      control={
        <Radio
          color="primary"
          onChange={onChange}
          value={value}
          checked={checked}
          {...otherProps}
        />
      }
      label={label}
    />
  </FormControl>
);

FormRadio.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  errors: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

export default FormRadio;
